
import { useEffect, useState } from 'react';

interface ChartLoaderProps {
  onChartLoaded: (loaded: boolean) => void;
}

const ChartLoader = ({ onChartLoaded }: ChartLoaderProps) => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      // Always remove any existing script to avoid duplicates
      const existingScript = document.getElementById('google-charts-loader');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }

      // Create a new script element with a unique ID
      const script = document.createElement('script');
      script.id = 'google-charts-loader';
      script.src = 'https://www.gstatic.com/charts/loader.js';
      script.async = true;
      script.onload = () => {
        // Wait for window.google to be defined before proceeding
        const checkGoogle = setInterval(() => {
          if (window.google && window.google.charts) {
            clearInterval(checkGoogle);
            window.google.charts.load('current', { packages: ['gantt'] });
            window.google.charts.setOnLoadCallback(() => {
              console.log('Google Charts loaded successfully');
              onChartLoaded(true);
            });
          }
        }, 100);
      };
      
      document.head.appendChild(script);
      
      return () => {
        // Clean up when component unmounts
        if (document.getElementById('google-charts-loader')) {
          document.head.removeChild(document.getElementById('google-charts-loader')!);
        }
      };
    }

    return undefined;
  }, [onChartLoaded]);

  return null; // This component has no UI
};

export default ChartLoader;
